// auth.interceptor.ts
import { environment } from "@environments/environment";
import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AuthService } from "@auth0/auth0-angular";
import { concatMap, map, of, switchMap, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { API_CONST } from "../constants/api.constants";
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const jwtHelper = new JwtHelperService();
  if (!req.url.includes(environment.apiUrl)) {
    return next(req);
  }

  // Exclude public endpoints that don't require authentication
  if (
    req.url.includes(API_CONST.USER.INDIVIDUAL_SIGNUP) ||
    req.url.includes(API_CONST.USER.VERIFY_EMAIL) ||
    req.url.includes(API_CONST.USER.RESEND_VERIFICATION) ||
    req.url.includes(API_CONST.INVOICE.GET_BY_ID_PUBLIC.replace(":invoiceId", "")) ||
    req.url.includes(API_CONST.PAYMENT.GET_PAYMENT_METHODS_PUBLIC) ||
    req.url.includes(API_CONST.PAYMENT.CREATE_PAYIN_REQUEST_PUBLIC) ||
    req.url.includes(API_CONST.PAYMENT.GET_VA_PUBLIC) ||
    req.url.includes(API_CONST.PAYMENT.GCA_SWIFT_ENABLED_PUBLIC) ||
    req.url.includes(API_CONST.PAYMENT.GET_GCA_VA_PUBLIC) ||
    req.url.includes(API_CONST.PAYMENT.COMPLETE_PAYIN_REQUEST_PUBLIC) ||
    req.url.includes(API_CONST.PAYMENT.CREATE_PAYMENT_CHECKING_REQUEST_PUBLIC) ||
    req.url.includes(API_CONST.PAYMENT.CREATE_CREDIT_CARD_PAYIN_REQUEST_PUBLIC)
  ) {
    return next(req);
  }

  // console.log("Intercepting request");

  return auth
    .getAccessTokenSilently({
      detailedResponse: true,
      cacheMode: "on",
    })
    .pipe(
      switchMap((tokenResponse) => {
        if (jwtHelper.isTokenExpired(tokenResponse.access_token)) {
          return auth.getAccessTokenSilently({
            detailedResponse: true,
            cacheMode: "off",
          });
        }
        return of(tokenResponse);
      }),
      concatMap((tokenResponse) => {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });
        return next(req).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              return event.clone({
                body: event.body?.data,
              });
            }
            return event;
          }),
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse) {
              console.error("HTTP error:", error);
            } else {
              console.error("Non-HTTP error:", error);
            }
            return throwError(() => error);
          })
        );
      })
    );
};
